const SAFE_REFERRERS = ['https://mail.google.com/'];
export const checkSafeOpener = () => {
  if (window.opener) {
    try {
      if (window.opener.origin) {
        console.log('safe origin');
      }
    } catch (error) {
      if (SAFE_REFERRERS.includes(document.referrer)) {
        console.log('safe referrer');
      } else {
        console.log('unsafe');
        window.opener = null;
      }
    }
  } else {
    console.log('safe no opener');
  }
};